<template>
  <table class="text-left bg-gray-200 table-fixed w-full rounded-md border-separate border-spacing-0">
    <thead class="relative -top-[1px] left-0 right-0 z-20">
      <slot name="table-header"></slot>
    </thead>
     <slot name="table-body" class="relative -top-[1px]"></slot>
    <!-- <tbody class="relative -top-[1px]">
      <slot name="table-body"></slot>
    </tbody> -->
    <tfoot class="fixed bottom-0 z-10" :style="footerStyle">
      <slot name="table-footer"></slot>
    </tfoot>
  </table>
  </template>

<script>
export default {
  name: "CustomTableTemplate",
  mounted () {
    var thElm;
    var startOffset;

    Array.prototype.forEach.call(
    document.querySelectorAll("table th"),
    function (th) {
      
      var grip = document.createElement('div');
      grip.innerHTML = "&nbsp;";
      grip.style.top = 0;
      grip.style.right = 0;
      grip.style.bottom = 0;
      grip.style.width = '5px';
      grip.style.position = 'absolute';
      grip.style.cursor = 'col-resize';
      grip.addEventListener('mousedown', function (e) {
            thElm = th;
            startOffset = th.offsetWidth - e.pageX;
        });

        th.appendChild(grip);
    });

    document.addEventListener('mousemove', function (e) {
        if (thElm) {
            thElm.style.width = startOffset + e.pageX + 'px';
        }
    });

    document.addEventListener('mouseup', function () {
        thElm = undefined;

    });
}

}
</script>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['visibleControlPanel', 'controlPanelWidth'])

const footerStyle = computed(() => {
  if(props.visibleControlPanel && props.controlPanelWidth) {
    // let width = `w-[calc(100vw-${props.controlPanelWidth.replace('w-[', '').replace('px]', '')}px)]`
    let pixelWidth = props.controlPanelWidth.replace('w-[', '').replace('px]', '')
    return `width: calc(100vw - ${pixelWidth}px);`
  }
  return 'width: 100%'
  // return 'width: inherit; max-width: inherit;'
})

</script>

<style scoped>
::-webkit-scrollbar{
  height: 0px;
  width: 3px;
}
::-webkit-scrollbar-thumb:horizontal{
  background: #D1D5DB;
  border-radius: 3px;
}
</style>